import {log} from 'util';

// 将编辑框内容html样式转化为latex编码
export function htmlToLatex(text) {
  var result = text
  //$$标签内容不做任何处理，先使用<>括起
  result = result.replace(/\$\$(\$[^$]+|[^$]*)*\$\$/g, function (match) {
    return '<' + match + '>';
  })

  // 删除标签内的回车
  result = result.replace(/<[^(>|\/)]*>(\n)*/g, function ($1, $2, $3, $4, $5) {
    const data = $1.replace($2, '')
    return data
  })
  result = result.replace(/(\n)*<\/[^>]*>/g, function ($1, $2, $3, $4, $5) {
    const data = $1.replace($2, '')
    return data
  })

  // 去掉标签外空格、并删除非span、BIU、$$标签
  //   result = result.replace(/\s+(?![^<>]+>)/g, '');

  result = result.replace(/<(?!\/?(span|strong|em|u|\$\$))[^>]*>/gi, '')
  //删除修饰内容为空的样式
  result = result.replace(/<(?!\$\$|\/)[^>]*><\/[^>]*>/g, '')
  //替换BIU
  result = result.replace(/<(st)[^>]*>/gi, '\\ywstriking{')
  result = result.replace(/<(e)[^>]*>/gi, '\\ywitalic{')
  result = result.replace(/<(u)[^>]*>/gi, '\\underline{')
  result = result.replace(/<\/(st|e|u)[^>]*>/gi, '}')

  //替换style：颜色字号字体
  result = _replaceSpan(result)

  //还原$$内容
  result = result.replace(/<(\$\$[^>]*)>/g, function (match, content) {
    return content
  })
  //将文本框转义的html标签还原
  return _unescapeHtml(result)
}

// 将编辑框转义的html特殊字符还原
function _unescapeHtml(val) {
  return val.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&amp;/g, '&').replace(/&nbsp;/g, ' ').replace(/&emsp;/g, '　')
}

// 递归替换span标签内的样式
function _replaceSpan(text) {
  var result = text
  var tail = ['', '}', '}}', '}}}']
  var size = ['smaller', 'small', 'default', 'large', 'larger']
  while (/<span[^>]*>(<\$\$[^>]*>|[^<])*<\/span>/.test(result)) {
    result = result.replace(/<span[^>]*>((<\$\$[^>]*>|[^<])*)<\/span>/g, function (matchStr, content) {
      var head = '';
      var style = matchStr.match(/[^"]*(?=;">)/)
      if (style == null) {
        return content
      }
      style = style[0].split(';')
      style.forEach(function (item) {
        item = item.split(':')
        if (item[0] == 'font-size') {
          head += '\\yw' + size[(parseInt(item[1], 10) - 10) / 2] + '{';
        } else {
          head += '\\yw' + item[1] + '{';
        }
      })
      return head + content + tail[style.length]
    })
  }
  return result
}

// 将latex编码样式转化为html
export function latexToHtml(text, size, type) {
  var sizeTag = ['smaller', 'small', 'default', 'large', 'larger']
  var BIUTag = ['striking', 'italic', 'underline']
  var BIUValue = ['b', 'i', 'u']
  var fontNameTag = ['SimSun', 'Kaiti', 'YaHei', 'SimHei', 'LiSu', 'Fangsong']
  var colorTag = ['darkred', 'red', 'orange', 'yellow', 'palegreen', 'green', 'deepskyblue', 'blue', 'darkblue', 'purple']

  var result = text
  // 替换&gt;和&lt;
  result = result.replace(/</gim, '&lt;')
  result = result.replace(/>/gim, '&gt;')
  size = (typeof size === 'undefined') ? 10 : size - 4
  type = (typeof type === 'undefined') ? 'px' : type

  //$$标签内容不做任何处理，先使用<>括起
  result = result.replace(/\$\$(\$?[^$])*\$\$/g, function (match) {
    return '<' + match + '>';
  })
  //underline加上yw
  result = result.replace(/\\underline{/g, '\\ywunderline{')

  while (/\\yw[^{}]*{(<\$\$[^>]*>|\\[{}]|[^{}])*}/.test(result)) {
    result = result.replace(/\\yw([^{}]*){((<\$\$[^>]*>|\\[{}]|[^{}])*)}/g, function (matchStr, style, content) {
      var head = '',
        tail = '';
      var index
      if ((index = BIUTag.indexOf(style.trim())) >= 0) {
        head = '<' + BIUValue[index] + '>';
        tail = '</' + BIUValue[index] + '>';
      } else if ((index = sizeTag.indexOf(style.trim())) >= 0 && index != 2) {
        head = '<span style="font-size:' + (size + 2 * index) + type + ';">';
        tail = '</span>';
      } else if (fontNameTag.indexOf(style.trim()) >= 0) {
        head = '<span style="font-family:' + style.trim() + ';">';
        tail = '</span>';
      } else if (colorTag.indexOf(style.trim()) >= 0) {
        head = '<span style="color:' + style + ';">';
        tail = '</span>';
      } else {
        head = '<latex' + style.trim() + '>';
        tail = '</latex>';
      }
      return head + content + tail
    })
  }

  // 还原其它latex文本
  result = result.replace(/<latex([^<>]*)>/g, function (matchStr, content) {
    return '\\yw' + content + '{';
  })
  result = result.replace(/<\/latex>/g, '}')
  //正文{}去掉转义，<$$ $$>内的不进行转化
  result = result.replace(/\\}(?!(\$?[^$])*\$\$>)/g, '}').replace(/\\{(?!(\$?[^$])*\$\$>)/g, '{')
  //还原$$内容
  result = result.replace(/<(\$\$(\$?[^$])*\$\$)>/g, function (match, content) {
    return content
  })
  // 替换换行为br
  result = result.replace(/\n/gi, function (match) {
    return '<br />'
  })
  // 还原< >
  result = result.replace(/&lt;/gim, '<')
  result = result.replace(/&gt;/gim, '>')
  return result
}

export function previewMaterial(scale, ptype, data) {
  fontSize = '14pt'
  if (ptype == '_courseware') {
    dialogWidth = 890
    dialogHeight = 720
    fontSize = '24pt'
    content = content.replace(new RegExp('^\\§§+|\\§§+$', 'g'), '')
    content = content.replace(new RegExp('\\§§+', 'g'), '§§')
    replaceStr = '<br><br><hr style="height:1px;width:850px;background-color:gray;border:none;"><br>'
    content = content.replace(new RegExp('§§', 'g'), replaceStr)
    content = latexToHtml(content, 24, 'pt')
  } else {
    content = latexToHtml(content, 14, 'pt')
  }
  // 替换ubb
  replaceUbbStr = JsUBB(content)

  noSaveImg = ''
  //替换图片
  pattern = new RegExp('\\[img=([^\\[]*)\\]', 'g')
  replaceImgStr = replaceUbbStr.replace(pattern, function ($1, $2) {
    if (type === 1) {
      imgObj = $('img[title="' + $2 + '"]')
      src = imgObj.attr('src')
      if (src.indexOf('base64') != -1) {
        noSaveImg += $2 + ','
      } else {
        scalewidth = Math.round(imgObj.attr('realwidth') * scale)
        scalewidth = scalewidth > (dialogWidth - 40) ? (dialogWidth - 40) : scalewidth
        scaleheight = Math.round(scalewidth / imgObj.attr('realwidth') * imgObj.attr('realheight'))
        potpos = src.lastIndexOf('.')
        src = src.substr(0, potpos) + '_' + scalewidth + 'x' + scaleheight + src.substr(potpos)
      }
    }

    if (type === 2) {
      src = resource[$2]
    }
    if (src === undefined) {
      return $1
    }

    return '<img src=' + src + '>'
  })
}

export function JsUBB(str) {
  // 粗体
  var re = /\[b\](.[^\[]*)\[\/b\]/gi
  str = str.replace(re, '<b>$1</b>')

  //斜体字
  re = /\[i\](.[^\[]*)\[\/i\]/gi
  str = str.replace(re, '<i>$1</i>')

  //下划线
  re = /\[u\](.[^\[]*)\[\/u\]/gi
  str = str.replace(re, '<u>$1</u>')

  //文本下面加点
  re = /\[d\](.[^\[]*)\[\/d\]/gi
  str = str.replace(re, "<span class='typo-em'>$1</span>")

  //文本下面加波浪线
  re = /\[w\](.[^\[]*)\[\/w\]/gi
  str = str.replace(re, "<span class='wave'>$1</span>")

  //上标
  re = /\[sub\](.[^\[]*)\[\/sub\]/gi
  str = str.replace(re, '<sub>$1</sub>')

  //下标
  re = /\[sup\](.[^\[]*)\[\/sup\]/gi
  str = str.replace(re, '<sup>$1</sup>')

  //字体大小
  re = /\[size=(\d+)\](.[^\[]*)\[\/size\]/gi
  str = str.replace(re, function (s1, s2, s3) {
    return '<span style="font-size: ' + s2 + 'px">' + s3 + '</span>'
  })

  //填空题中的空隔，num表示空的数量（可输入的文字数量，不区分中英文）
  re = /\[blank=(\d+)\]/gi
  str = str.replace(re, function (s1, s2) {
    var _t1 = s2 * 12
    return '<span class="test_blank" style="width:' + _t1 + 'px">&nbsp;</span>'
  })
  return str
}



// WEBPACK FOOTER //
// ./packages/material-content/utils/latex.js